import { render, staticRenderFns } from "./q2.vue?vue&type=template&id=7e9607ca"
import script from "./q2.vue?vue&type=script&lang=js"
export * from "./q2.vue?vue&type=script&lang=js"
import style0 from "./q2.vue?vue&type=style&index=0&id=7e9607ca&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports